import React, { useRef } from 'react'
import { makeStyles } from '@material-ui/core'
import VolumeUpIcon from '@material-ui/icons/VolumeUp'

import SmartAutocomplete from './SmartAutocomplete'
import SmartIconButton from './SmartIconButton'

type scaleModeType = {
	value: string,
	name: string,
	category: string
}

const useStyles = makeStyles((theme) => ({
	iconButtonPlay: {
		marginLeft: 4,
		width: 76,
		height: 76,
		color: 'darkgrey',
		transition: 'color 0.25s',
		'&:hover': {
			color: 'lightgray',
		},
	},
	iconPlay: {
		fontSize: 40,
	},
}))

const ScaleSettings = (props: {
	roots: string[],
	scalesMode: scaleModeType[],
	root: string,
	scaleMode: scaleModeType,
	onRootChange: (root: string) => void,
	onScaleModeChange: (scaleMode: scaleModeType) => void,
	onPlayClick: () => void
}) => {

	const {
		roots,
		scalesMode,
		root,
		scaleMode,
		onRootChange,
		onScaleModeChange,
		onPlayClick
	} = props

	const classes = useStyles()

	return (
		<div id='scale-settings' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: 64 }}>
			
			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

				{/* // TODO : also handle enharmonic press, then if it's # and we're in b switch to # notation */}
				<SmartAutocomplete
					keyName='r'
					label="Root"
					value={root}
					options={root.length > 0 ? roots.sort((r1: string, r2: string) => r1 < r2 ? -1 : r1 > r2 ? 1 : 0) : roots}
					getOptionLabel={(option) => option}
					style={{ width: 100, margin: 16 }}
					onChange={(e, root) => root && onRootChange(root)}
				/>

				<SmartAutocomplete
					keyName='m'
					label="Mode"
					// autoComplete
					// blurOnSelect
					value={scaleMode}
					options={scalesMode}
					getOptionLabel={(option) => option.name}
					groupBy={option => option.category}
					style={{ width: 450, margin: 16 }}
					onChange={(e, scaleMode) => scaleMode && onScaleModeChange(scaleMode)}
				/>

				<SmartIconButton keyName='l' onClick={onPlayClick} className={classes.iconButtonPlay} aria-label="play audio">
					<VolumeUpIcon className={classes.iconPlay} />
				</SmartIconButton>

			</div>
		</div>
	)
}

export default ScaleSettings

// TODO : show that notes are playing

// TODO : maybe if any key is pressed, start writing in root input